import { TUserTokenDto } from './api'

const getAuthToken = (): string => {
    return typeof window !== 'undefined' ? localStorage.getItem('authToken') : null
}
const getUserToken = (): TUserTokenDto | null => {
    const userToken = typeof window !== 'undefined' ? localStorage.getItem('userToken') : null
    return userToken ? JSON.parse(userToken) : null
}

const setAuthToken = (authToken: string): void => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('authToken', authToken)
    }
}

const setUserToken = (userToken: TUserTokenDto): void => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('userToken', JSON.stringify(userToken))
    }
}

const getRefreshToken = (): string => {
    const userToken: TUserTokenDto | null = getUserToken()
    return userToken ? userToken.refresh_token : ''
}

const getUserName = (): string => {
    const userToken: TUserTokenDto | null = getUserToken()
    return userToken ? userToken.username : ''
}

const getReferralToken = (): string | null => {
    return typeof window !== 'undefined' ? localStorage.getItem('referralToken') : null
}

const setReferralToken = (referralToken: string): void => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('referralToken', referralToken)
    }
}

export {
    getAuthToken,
    getUserToken,
    setAuthToken,
    setUserToken,
    getRefreshToken,
    getUserName,
    getReferralToken,
    setReferralToken
}
